import { createFileRoute } from '@tanstack/react-router';
import CollectionDataPage from '@/pages/workspaces/journeys/collections/[collectionId]/data.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { LazyPage } from './-route-layouts';

function CollectionDataRoute() {
  return (
    <LazyPage>
      <RumPageRendered>
        <CollectionDataPage />
      </RumPageRendered>
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data')(
  {
    component: CollectionDataRoute,
  },
);
